
// region JS Imports

// region External Modules
import $ from "jquery"
import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
import { getDataFromLocalStorage } from "app/local_storages/native_api_adapter"

import dayjs from "plugins/dayjs/index"
import I18n from "plugins/i18n-js"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import DismissPeriodComparisonModal from "./../../dismiss_period_comparison_modal"

import {
  Factory as CompareSectionFactory,
  CompareSection,
} from "./../../compare_section/index"
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope:         string
  duration_item: string

  main:   string
  menu:   string
  toggle: string

  dropdown_label_placeholder:                  string
  dropdown_label_month_range_text:             string
  dropdown_label_month_range_start_date_text:  string
  dropdown_label_month_range_end_date_text:    string

  month_start_text_label: string
  month_end_text_label:   string

  month_start_text_input:         string
  month_end_text_input:           string
  month_range_calendar_error_msg: string

  month_range_calendars_container:    string
  month_range_angle_up:               string
  month_range_angle_down:             string
  month_range_calendar_container:     string
  previous_calender_button:           string
  next_calender_button:               string
  month_range_calendar_month_button:  string

  cancel_button:   string
  confirm_button:  string
}
interface InputSelector {
  scope?:         string
  duration_item?: string

  main?:    string
  menu?:    string
  toggle?:  string

  dropdown_label_placeholder?:                 string
  dropdown_label_month_range_text?:            string
  dropdown_label_month_range_start_date_text?: string
  dropdown_label_month_range_end_date_text?:   string

  month_start_text_label?: string
  month_end_text_label?:   string

  month_start_text_input?:         string
  month_end_text_input?:           string
  month_range_calendar_error_msg?: string

  month_range_calendars_container?:   string
  month_range_angle_up?:              string
  month_range_angle_down?:            string
  month_range_calendar_container?:    string
  previous_calender_button?:          string
  next_calender_button?:              string
  month_range_calendar_month_button?: string

  cancel_button?:   string
  confirm_button?:  string
}

const DEFAULT_SELECTOR = {
  scope:          ".page--building-level-real-estate-transactions-page--filter-bar-desktop",
  duration_item:  ".page--building-level-real-estate-transactions-page--filter-bar-desktop-option",

  main:       ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range",
  menu:       ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-date-range_dropdown",
  toggle:     ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-toggle",

  dropdown_label_placeholder:                  ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-toggle-placeholder",
  dropdown_label_month_range_text:             ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-toggle-date-range-text",
  dropdown_label_month_range_start_date_text:  ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-date-range_dropdown-start-date",
  dropdown_label_month_range_end_date_text:    ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-date-range_dropdown-end-date",

  month_start_text_label: ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-start-label",
  month_end_text_label:   ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-end-label",

  month_start_text_input:         ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range--start-date-input",
  month_end_text_input:           ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range--end-date-input",
  month_range_calendar_error_msg: ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range_dropdown-error-msg",

  month_range_calendars_container:   ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range_dropdown-calendars-container",
  month_range_angle_up:              ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-angle-up",
  month_range_angle_down:            ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range-angle-down",
  month_range_calendar_container:    ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range_dropdown-calendar-container",
  previous_calender_button:          ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range_dropdown-previous-calendar-button",
  next_calender_button:              ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range_dropdown-next-calendar-button",
  month_range_calendar_month_button: ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-month-range_dropdown-calendar-month-button",

  cancel_button:  ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-date-range_dropdown-cancel-button",
  confirm_button: ".page--building-level-real-estate-transactions-page--filter-bar-desktop-custom-date-range_dropdown-confirm-button",
}


class MonthRangeSelectMenu extends EventEmitter {
  protected selector: Selector

  protected $scope:         JQuery
  protected $duration_item: JQuery

  protected $main:   JQuery
  protected $menu:   JQuery
  protected $toggle: JQuery

  protected $dropdown_label_placeholder:                 JQuery
  protected $dropdown_label_month_range_text:            JQuery
  protected $dropdown_label_month_range_start_date_text: JQuery
  protected $dropdown_label_month_range_end_date_text:   JQuery

  protected $month_start_text_label:  JQuery
  protected $month_end_text_label:    JQuery

  protected $month_start_text_input:         JQuery
  protected $month_end_text_input:           JQuery
  protected $month_range_calendar_error_msg: JQuery

  protected $month_range_calendars_container:     JQuery
  protected $month_range_angle_up:                JQuery
  protected $month_range_angle_down:              JQuery
  protected $month_range_calendar_container:      JQuery
  protected $previous_calender_button:            JQuery
  protected $next_calender_button:                JQuery
  protected $month_range_calendar_month_button:   JQuery

  protected $cancel_button:   JQuery
  protected $confirm_button:  JQuery

  protected compare_section: CompareSection

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)
    this.$duration_item = this.$scope.find(this.selector.duration_item)

    this.$main = this.$scope.find(this.selector.main)
    this.$menu = this.$scope.find(this.selector.menu)
    this.$toggle = this.$main.find(this.selector.toggle)

    this.$dropdown_label_placeholder = this.$scope.find(this.selector.dropdown_label_placeholder)
    this.$dropdown_label_month_range_text = this.$scope.find(this.selector.dropdown_label_month_range_text)
    this.$dropdown_label_month_range_start_date_text = this.$scope.find(this.selector.dropdown_label_month_range_start_date_text)
    this.$dropdown_label_month_range_end_date_text = this.$scope.find(this.selector.dropdown_label_month_range_end_date_text)

    this.$month_start_text_label = this.$scope.find(this.selector.month_start_text_label)
    this.$month_end_text_label = this.$scope.find(this.selector.month_end_text_label)

    this.$month_start_text_input = this.$scope.find(this.selector.month_start_text_input)
    this.$month_end_text_input = this.$scope.find(this.selector.month_end_text_input)
    this.$month_range_calendar_error_msg = this.$scope.find(this.selector.month_range_calendar_error_msg)

    this.$month_range_calendars_container = this.$scope.find(this.selector.month_range_calendars_container)
    this.$month_range_angle_up = this.$scope.find(this.selector.month_range_angle_up)
    this.$month_range_angle_down = this.$scope.find(this.selector.month_range_angle_down)
    this.$month_range_calendar_container = this.$scope.find(this.selector.month_range_calendar_container)
    this.$previous_calender_button = this.$scope.find(this.selector.previous_calender_button)
    this.$next_calender_button = this.$scope.find(this.selector.next_calender_button)
    this.$month_range_calendar_month_button = this.$scope.find(this.selector.month_range_calendar_month_button)

    this.$cancel_button = this.$scope.find(this.selector.cancel_button)
    this.$confirm_button = this.$scope.find(this.selector.confirm_button)

    this.compare_section = CompareSectionFactory.instance()

    this.created()
    this.bind_action()
  }

  protected created() {
    const $target_duration_item = this.$duration_item.filter(".with-data--selected")

    this.on_duration_item_select($target_duration_item)
  }

  protected updateText(){
    if (this.$month_start_text_input.val() && this.$month_end_text_input.val()){
      this.$dropdown_label_placeholder.hide()
      this.$dropdown_label_month_range_text.addClass("active")

      this.$toggle.addClass("with-data--selected")
      this.$toggle.find("i").addClass("with-data--selected")

      this.$dropdown_label_month_range_start_date_text.text(this.$month_start_text_input.val() as string)
      this.$dropdown_label_month_range_end_date_text.text(this.$month_end_text_input.val() as string)
    }
    else {
      this.$dropdown_label_placeholder.show()
      this.$dropdown_label_month_range_text.removeClass("active")

      this.$toggle.removeClass("with-data--selected")
      this.$toggle.find("i").removeClass("with-data--selected")
    }
  }

  protected bind_action(){

    // region duration selection

    this.$duration_item.on("click", (e) => {
      const $target_duration_item = $(e.currentTarget)

      if ( $(e.currentTarget).hasClass("with-data--selected") ) {
        return
      }

      if ( $(e.currentTarget).data("duration") === "all" && this.compare_section.is_period_comparison_selected() ) {
        if ( getDataFromLocalStorage("not_showing_dismiss_period_comparison_dropdown_again").data == null ) {
          DismissPeriodComparisonModal.init()
        }
        else {
          this.on_duration_item_select($target_duration_item)
        }
      }
      else {
        this.on_duration_item_select($target_duration_item)
      }
    })

    // endregion duration selection


    // region custom month range selection

    this.$toggle.on("click", () => {
      if (this.$menu.hasClass("active")) {
        this.$menu.removeClass("active")
      }
      else {
        this.$menu.addClass("active")
      }

      this.$month_range_calendars_container.show()
      this.$month_range_angle_up.hide()
      this.$month_range_angle_down.show()
      this.update_calendars_switch_buttons_style()


      // region reset to original selected value if any

      if ( this.$month_start_text_input.attr("previous_confirmed_value") != null && this.$month_end_text_input.attr("previous_confirmed_value") != null ) {
        this.$month_start_text_input.val(this.$month_start_text_input.attr("previous_confirmed_value") as string)
        this.$month_end_text_input.val(this.$month_end_text_input.attr("previous_confirmed_value") as string)
      }
      this.on_input_value_change(this.$month_start_text_input)
      this.on_input_value_change(this.$month_end_text_input)
      this.show_target_calendar(this.$month_start_text_input)

      // endregion reset to original selected value if any
    })


    // region calendar display and update behavior

    this.$month_range_angle_up.on("click", () => {
      this.$month_range_calendars_container.show()
      this.$month_range_angle_up.hide()
      this.$month_range_angle_down.show()
    })

    this.$month_range_angle_down.on("click", () => {
      this.$month_range_calendars_container.hide()
      this.$month_range_angle_up.show()
      this.$month_range_angle_down.hide()
    })

    this.$previous_calender_button.on("click", () => {
      const current_calendar_index = parseInt(this.$month_range_calendar_container.filter(".active").attr("index") as string)

      if (current_calendar_index === 0) {
        return
      }

      this.$month_range_calendar_container.removeClass("active")
      this.$month_range_calendar_container.filter(`[index=${current_calendar_index - 1}]`).addClass("active")
      this.update_calendars_switch_buttons_style()
    })

    this.$next_calender_button.on("click", () => {
      const current_calendar_index = parseInt(this.$month_range_calendar_container.filter(".active").attr("index") as string)
      const max_index = this.$month_range_calendar_container.length

      if (current_calendar_index === max_index) {
        return
      }

      this.$month_range_calendar_container.removeClass("active")
      this.$month_range_calendar_container.filter(`[index=${current_calendar_index + 1}]`).addClass("active")
      this.update_calendars_switch_buttons_style()
    })

    this.$month_range_calendar_month_button.each((_idx, el) => {
      $(el).on("click", () => {
        const number_of_selected_months = this.$month_range_calendar_month_button.filter(".selected").length

        if ($(el).hasClass("disabled")) {
          return
        }

        if (number_of_selected_months >= 2) {
          this.$month_range_calendar_month_button.removeClass("selected")
        }

        if ($(el).hasClass("selected")) {
          $(el).removeClass("selected")
        }
        else {
          $(el).addClass("selected")
        }

        this.$month_start_text_input.val("")
        this.$month_end_text_input.val("")
        this.$month_range_calendar_error_msg.hide()

        this.$month_range_calendar_month_button.filter(".selected").each((_idy, button_el) => {
          const month_value = $(button_el).attr("data") as string

          if (_idy === 0){
            this.$month_start_text_input.val(month_value)
            this.$month_start_text_input.removeClass("invalid")
          }
          else {
            this.$month_end_text_input.val(month_value)
            this.$month_end_text_input.removeClass("invalid")
          }
        })

        this.update_confirm_button_and_error_msg_status()
        this.update_calendar_style()
      })
    })

    // endregion calendar display and update behavior


    // region on custom input behavior update

    // region start date

    this.$month_start_text_input.on("focus", () => {
      this.show_target_calendar(this.$month_start_text_input)
    })

    this.$month_start_text_input.on("input", () => {
      const previous_input_value = this.$month_start_text_input.attr("previous_input_value") as string
      const original_input_value = this.$month_start_text_input.val() as string

      this.$month_start_text_input.val(this.input_val_processing(original_input_value, previous_input_value))

      this.show_target_calendar(this.$month_start_text_input)
      this.on_input_value_change(this.$month_start_text_input)

      // store previous input value
      this.$month_start_text_input.attr("previous_input_value", this.$month_start_text_input.val() as string)
    })

    // endregion start date

    // region end date

    this.$month_end_text_input.on("focus", () => {
      this.show_target_calendar(this.$month_end_text_input)
    })

    this.$month_end_text_input.on("input", () => {
      const previous_input_value = this.$month_end_text_input.attr("previous_input_value") as string
      const original_input_value = this.$month_end_text_input.val() as string

      this.$month_end_text_input.val(this.input_val_processing(original_input_value, previous_input_value))

      this.show_target_calendar(this.$month_end_text_input)
      this.on_input_value_change(this.$month_end_text_input)

      // store previous input value
      this.$month_end_text_input.attr("previous_input_value", this.$month_end_text_input.val() as string)
    })

    // endregion end date

    // endregion on custom input behavior update

    this.$confirm_button.on("click",() => {
      if ( this.$confirm_button.hasClass("valid")) {
        this.$duration_item.removeClass("with-data--selected")

        this.$menu.removeClass("active")

        this.compare_section.set_availability_of_period_comparison("")
        this.compare_section.set_period_comparison_option_text("", `${this.$month_start_text_input.val() as string} - ${this.$month_end_text_input.val() as string}`)

        // store previous confirmed value
        this.$month_start_text_input.attr("previous_confirmed_value", this.$month_start_text_input.val() as string)
        this.$month_end_text_input.attr("previous_confirmed_value", this.$month_end_text_input.val() as string)

        this.updateText()

        this.emit("val_change")
      }
    })

    this.$cancel_button.on("click", () => {
      this.$menu.removeClass("active")
    })

    onClickOutside(this.$main[0] as HTMLElement, () => {
      this.$menu.removeClass("active")
    })

    // endregion custom month range selection
  }

  public on_duration_item_select($target_duration_item: JQuery<HTMLElement>) {
    // region reset custom month range dropdown label to default

    this.$dropdown_label_placeholder.show()
    this.$dropdown_label_month_range_text.removeClass("active")

    this.$toggle.removeClass("with-data--selected")
    this.$toggle.find("i").removeClass("with-data--selected")

    // endregion reset custom month range dropdown label to default

    const duration_selected = $target_duration_item.data("duration") as string

    this.$duration_item.removeClass("with-data--selected")
    $target_duration_item.addClass("with-data--selected")

    let start_date: any

    if ( duration_selected === "all") {
      start_date = new Date(1997,0, 1)
    }
    else {
      start_date = new Date(new Date().getFullYear(), new Date().getMonth() - parseInt(duration_selected), 1)
    }

    this.$month_start_text_input.val(dayjs(start_date).add(0, "month").format("MM/YYYY"))
    this.$month_end_text_input.val(dayjs(new Date()).add(0, "month").format("MM/YYYY"))

    // store previous confirmed value
    this.$month_start_text_input.attr("previous_confirmed_value", this.$month_start_text_input.val() as string)
    this.$month_end_text_input.attr("previous_confirmed_value", this.$month_end_text_input.val() as string)

    // store previous input value
    this.$month_start_text_input.attr("previous_input_value", this.$month_start_text_input.val() as string)
    this.$month_end_text_input.attr("previous_input_value", this.$month_end_text_input.val() as string)

    this.compare_section.set_availability_of_period_comparison(duration_selected)
    this.compare_section.set_period_comparison_option_text($target_duration_item.text(), `${this.$month_start_text_input.val() as string} - ${this.$month_end_text_input.val() as string}`)

    this.emit("val_change")
  }

  protected is_input_value_format_invalid(input_value: string) {
    return !dayjs(input_value, "MM/YYYY", true).isValid()
  }

  protected is_input_value_invalid(input_value: string) {
    const year = Number(input_value.split("/")[1])
    const month = Number(input_value.split("/")[0]) - 1

    const input_value_date_obj = new Date(year, month)

    const min_date = new Date(1997,0,1)
    const max_date = new Date()

    return (input_value_date_obj < min_date || input_value_date_obj > max_date)
  }

  protected is_start_month_greater_than_end_month() {
    const start_date_string = this.$month_start_text_input.val() as string
    const end_date_string = this.$month_end_text_input.val() as string

    const start_date_obj = new Date(Number(start_date_string.split("/")[1]),Number(start_date_string.split("/")[0]))
    const end_date_obj = new Date(Number(end_date_string.split("/")[1]),Number(end_date_string.split("/")[0]))

    return start_date_obj > end_date_obj
  }

  protected input_val_processing(original_input_value: string, previous_input_value: string) {
    // not implement value processing when user delete input value
    if (previous_input_value?.length >= original_input_value?.length) {
      return original_input_value
    }

    // remove all unaccepted char input
    const processed_string_with_number_element_only = original_input_value.split(/[^0-9]/).join("")

    const month_part = processed_string_with_number_element_only.slice(0,2)
    const year_part = processed_string_with_number_element_only.slice(2, processed_string_with_number_element_only.length)

    if (processed_string_with_number_element_only.length > 1) {
      return `${month_part}/${year_part}`.slice(0,7)
    }
    else {
      return `${month_part}${year_part}`
    }
  }

  protected validate_input_value(input_jquery_element: JQuery<HTMLElement>) {
    const input_string = input_jquery_element.val() as string

    input_jquery_element.removeClass("invalid")

    if ( this.is_input_value_format_invalid(input_string) ) {
      input_jquery_element.addClass("invalid")

      this.$month_range_calendar_month_button.removeClass("selected")

      return
    }

    if ( this.is_input_value_invalid(input_string) ) {
      input_jquery_element.addClass("invalid")

      this.$month_range_calendar_month_button.removeClass("selected")

      this.$month_range_calendar_error_msg.text(I18n.t("apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.filter_bar.error_msg.invalid_range"))
      this.$month_range_calendar_error_msg.show()

      return
    }

    if ( this.is_start_month_greater_than_end_month() ) {
      this.$month_start_text_input.addClass("invalid")
      this.$month_end_text_input.addClass("invalid")

      this.$month_range_calendar_error_msg.text(I18n.t("apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.filter_bar.error_msg.end_date_earlier_than_start_date"))
      this.$month_range_calendar_error_msg.show()

      return
    }
  }

  protected on_input_value_change(input_jquery_element: JQuery<HTMLElement>) {
    const input_string = input_jquery_element.val() as string

    if ( input_string ) {
      this.validate_input_value(input_jquery_element)
    }
    else {
      input_jquery_element.removeClass("invalid")
    }

    this.show_target_calendar(input_jquery_element)
    this.update_selected_month_button_status()
    this.update_confirm_button_and_error_msg_status()
    this.update_calendar_style()
  }

  protected show_target_calendar(input_jquery_element: JQuery<HTMLElement>) {
    const input_value = input_jquery_element.val() as string
    const year = input_value.split("/")[1]

    if ( !this.is_input_value_format_invalid(input_value) ) {
      const target_container = this.$month_range_calendar_container.filter(`[year=${year}]`)

      if ( target_container.length > 0 ) {
        this.$month_range_calendar_container.removeClass("active")
        target_container.addClass("active")
      }

      this.update_calendars_switch_buttons_style()
    }
  }

  protected update_selected_month_button_status() {
    this.$month_range_calendar_month_button.removeClass("selected")

    const start_date_string = this.$month_start_text_input.val() as string
    const end_date_string = this.$month_end_text_input.val() as string

    if ( !this.is_input_value_format_invalid(start_date_string) && !this.is_input_value_invalid(start_date_string) && !this.is_start_month_greater_than_end_month() ) {
      const start_filter_text = start_date_string.split("/").join("")
      const target_button = this.$month_range_calendar_month_button.filter(`[filter_text=${start_filter_text}]`)

      if (!target_button.hasClass("disabled")){
        target_button.addClass("selected")
      }
    }

    if ( !this.is_input_value_format_invalid(end_date_string) && !this.is_input_value_invalid(end_date_string) && !this.is_start_month_greater_than_end_month() ) {
      const end_date_text = end_date_string.split("/").join("")
      const target_button = this.$month_range_calendar_month_button.filter(`[filter_text=${end_date_text}]`)

      if (!target_button.hasClass("disabled")){
        target_button.addClass("selected")
      }
    }
  }

  protected update_confirm_button_and_error_msg_status() {
    const start_date_string = this.$month_start_text_input.val() as string
    const end_date_string = this.$month_end_text_input.val() as string

    if ( this.is_input_value_format_invalid(start_date_string) || this.is_input_value_format_invalid(end_date_string)) {
      this.$confirm_button.removeClass("valid")
      this.$month_range_calendar_error_msg.hide()

      return
    }

    if ( this.is_input_value_invalid(start_date_string) || this.is_input_value_invalid(end_date_string) || this.is_start_month_greater_than_end_month()) {
      this.$confirm_button.removeClass("valid")
      this.$month_range_calendar_error_msg.show()

      return
    }

    this.$month_start_text_input.removeClass("invalid")
    this.$month_end_text_input.removeClass("invalid")
    this.$month_range_calendar_error_msg.hide()
    this.$confirm_button.addClass("valid")
  }

  protected update_calendars_switch_buttons_style() {
    const current_calendar_index = parseInt(this.$month_range_calendar_container.filter(".active").attr("index") as string)
    const max_index = this.$month_range_calendar_container.length

    // region reset two chevron button to default style

    this.$previous_calender_button.show()
    this.$next_calender_button.show()

    // endregion reset two chevron button to default style

    if (current_calendar_index + 1 >= max_index) {
      this.$next_calender_button.hide()
    }

    if (current_calendar_index <= 0) {
      this.$previous_calender_button.hide()
    }
  }

  protected update_calendar_style() {
    this.$month_range_calendar_month_button.removeClass("is_in_range")

    if (this.$month_range_calendar_month_button.filter(".selected").length < 2) {
      return
    }

    let start_index = 0
    let end_index = 0

    this.$month_range_calendar_month_button.filter(".selected").each((_idx, el) => {
      if (_idx === 0){
        start_index = parseInt($(el).attr("idx") as string)
      }
      else {
        end_index = parseInt($(el).attr("idx") as string)
      }
    })

    this.$month_range_calendar_month_button.each((_idx, el) => {
      if (_idx > start_index && _idx < end_index) {
        $(el).removeClass("selected")
        $(el).addClass("is_in_range")
      }
    })
  }

  public start_date() {
    return this.$month_start_text_input.val()
  }

  public end_date() {
    return this.$month_end_text_input.val()
  }

  public selected_button() {
    return this.$duration_item.filter(".with-data--selected")
  }

  public get_target_duration_item(duration: string) {
    return this.$duration_item.filter(`[data-duration=${duration}]`)
  }

  public reset() {
    this.$month_start_text_input.val("")
    this.$month_end_text_input.val("")
    this.updateText()
    this.$month_range_calendar_month_button.removeClass("selected")
    this.update_confirm_button_and_error_msg_status()
    this.update_calendar_style()
  }
}

const Factory = {
  _instance: null as null | MonthRangeSelectMenu,

  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new MonthRangeSelectMenu(selector)
  },
}

export {
  Factory,
  MonthRangeSelectMenu,
}
